module.exports = __webpack_public_path__ + "static/media/egos_mini.17670955.svg";